import React, { Suspense, memo } from 'react';
import { Provider } from 'react-redux';
import { store } from './stores/config-store';
import { SpinLoading } from './pages/loading';
import { RootRouter } from './routes';
import './styles/app.scss';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const App = memo(() => {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <Suspense fallback={<SpinLoading />}>
          <RootRouter />
        </Suspense>
      </Provider>
    </QueryClientProvider>
  );
});

App.displayName = 'MyApp';

export default App;
